import { TokenDecodeError } from "./error";

interface Token {
  version: string;
}

export interface TokenV1 extends Token {
  sessionId: string;
}

export function createToken(sessionId: string): TokenV1 {
  return {
    version: "1",
    sessionId,
  };
}

function isToken(value: unknown): value is Token {
  return (
    value != null &&
    typeof value === "object" &&
    "version" in value &&
    typeof value.version === "string"
  );
}

export function isTokenV1(token: Token): token is TokenV1 {
  return (
    token.version === "1" &&
    "sessionId" in token &&
    typeof token.sessionId === "string"
  );
}

export function encodeToken(token: TokenV1): string {
  const json = JSON.stringify(token);
  return btoa(json).replace("=", "");
}

export function decodeToken(obfuscatedToken: string): Token {
  try {
    const json = atob(obfuscatedToken);
    const data = JSON.parse(json) as unknown;

    if (!isToken(data)) {
      throw new TypeError("Token parsed contains invalid data");
    }

    if (data.version === "1") {
      if (!isTokenV1(data)) {
        throw new TypeError("Invalid v1 Token");
      }
      return data;
    }

    throw new TypeError("Unsupported token version");
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new TokenDecodeError(error.message);
    }
    if (error instanceof DOMException) {
      throw new TokenDecodeError(error.message);
    }
    throw error;
  }
}
